import { createContext, useCallback, useContext } from 'react';
// @ts-expect-error untyped dependency
import { generateLeadWithAction } from '../clients/ecosystemClient';
import { jsx as _jsx } from "react/jsx-runtime";
const LeadGenContext = /*#__PURE__*/createContext(undefined);
export const LeadGenProvider = ({
  children,
  offeringId,
  homemade,
  isPreview = false,
  offeringPortalId
}) => {
  const sendLead = useCallback(action => {
    if (!isPreview && offeringId) {
      try {
        generateLeadWithAction(offeringId, action);
      } catch (error) {
        console.error('Error sending lead:', error);
      }
    }
  }, [isPreview, offeringId]);
  const runLeadGen = useCallback(({
    onTrackInteraction,
    section,
    action
  }) => {
    if (!homemade) {
      if (onTrackInteraction) {
        onTrackInteraction('generated lead', {
          section,
          value: `${offeringPortalId}`
        });
      }
      sendLead(action);
    }
  }, [homemade, offeringPortalId, sendLead]);
  return /*#__PURE__*/_jsx(LeadGenContext.Provider, {
    value: {
      sendLead,
      runLeadGen
    },
    children: children
  });
};
export const useLeadGenContext = () => {
  const context = useContext(LeadGenContext);
  if (!context) {
    throw new Error('useLeadGenContext must be used within a LeadGenContext.Provider');
  }
  return context;
};